import { nameSpace } from '../slices';

export const messageSelector = (state) => state[nameSpace].message;
export const loadingSelector = (state) => state[nameSpace].loading;
